import moment from 'moment-timezone'
import { Card, CardContent, Typography, Stack, Box } from '@mui/material'
import { formatDisplayDate } from '../../../utils/helpers'

const formatLocalTimestamp = (value) => {
  if (!value) return null
  return moment.tz(value, moment.tz.guess()).format('LLLL z')
}

const StatusBadge = ({ positive, positiveText, negativeText }) => (
  <span className={`label ${positive ? 'bg-success' : 'bg-default'} text-white`}>
    {positive ? positiveText : negativeText}
  </span>
)

const Row = ({ label, children, timestamp }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <Box>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      {timestamp && (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          {typeof timestamp === 'string' ? (
            <Typography variant="caption" color="text.secondary">
              {timestamp}
            </Typography>
          ) : (
            timestamp
          )}
        </Box>
      )}
    </Box>
    {children}
  </Box>
)

const FollowUpStatusCard = ({ record }) => {
  const notifications = record?.patientNotifications || []
  const wasNotified = notifications.length > 0
  const lastNotification = wasNotified ? notifications[notifications.length - 1] : null

  // resultRetrievals is a Map/object ({ retrievalSuccessCount, ... }), not an
  // array — checking .length here always evaluates to undefined/falsy.
  const wasViewed = Boolean(record?.resultRetrievals?.retrievalSuccessCount > 0)

  const wasAcknowledged = Boolean(record?.providerAcknowledgedAt)

  const wasCouponSent = Boolean(record?.replacementCouponSentAt)

  return (
    <Card>
      <CardContent>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
          Follow-up Status
        </Typography>
        <Stack spacing={2}>
          {/* lastNotification.datetime is already a display-ready string (see
              mfh-api/endpoints/kits/kit.js: moment().tz(...).format('LLLL z')),
              not one of formatDisplayDate's accepted formats — show it as-is. */}
          <Row label="Patient Notified" timestamp={lastNotification ? lastNotification.datetime : null}>
            <StatusBadge positive={wasNotified} positiveText="Yes" negativeText="No" />
          </Row>
          <Row label="Patient Viewed Result">
            <StatusBadge positive={wasViewed} positiveText="Yes" negativeText="Not yet" />
          </Row>
          <Row
            label="Provider Acknowledged"
            timestamp={
              wasAcknowledged ? (
                <>
                  <Typography variant="caption" color="text.secondary">
                    {formatLocalTimestamp(record.providerAcknowledgedAt)}
                  </Typography>
                  {record.providerAcknowledgedBy && (
                    <Typography variant="caption" color="text.secondary">
                      by {record.providerAcknowledgedBy}
                    </Typography>
                  )}
                </>
              ) : null
            }
          >
            <StatusBadge positive={wasAcknowledged} positiveText="Yes" negativeText="No" />
          </Row>
          <Row
            label="Replacement Coupon Sent"
            timestamp={wasCouponSent ? formatLocalTimestamp(record.replacementCouponSentAt) : null}
          >
            <StatusBadge positive={wasCouponSent} positiveText="Yes" negativeText="No" />
          </Row>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default FollowUpStatusCard
